// extracted by mini-css-extract-plugin
var _1 = "FilePreviewImage-moduleFilePreviewImage__wGAkg";
var _2 = "FilePreviewImage-modulecontain__oWShP";
var _3 = "FilePreviewImage-modulefill__QykoE";
var _4 = "FilePreviewImage-moduleimg__sfe1I";
var _5 = "FilePreviewImage-modulevertical__SD0tB";
export { _1 as "FilePreviewImage", _2 as "contain", _3 as "fill", _4 as "img", _5 as "vertical" }
